<app-ag-grid-table
  *ngIf="columnSelection"
  [entity]="entity"
  [columnDefs]="columnDefs"
  [columnSelection]="columnSelection"
>
</app-ag-grid-table>
